/**
 * `/orgs/:orgId/` 하위 전체를 org access token 대상으로 넓게 매칭한다(2026-07-23, sms
 * `org-scoped-route.ts`에서 lib으로 승격 — 2026-08-19, 3번째 소비처(sbe-commerce)가 생기며
 * sms/timetable에 완전히 동일하게(diff 0) 복붙돼 있던 로컬 파일을 여기로 합쳤다). 리소스별로
 * 실제 org 토큰이 필요한지는 앱·백엔드 가드마다 다르지만(예: sms의 `OrgScopeGuard`가 지키는
 * 4개 리소스만 필수, 나머지는 `claims.sub` 기반 라이브 체크라 org 토큰이 붙어도 personal
 * 토큰과 동일하게 동작), 굳이 앱마다 리소스별로 좁게 나열하지 않고 `/orgs/:orgId/` 하위
 * 전체를 넓게 매칭하는 게 세 앱(sms/timetable/commerce) 공통 관례다.
 *
 * `/orgs`(목록)·`/orgs/:orgId`(상세, 하위 세그먼트 없음)는 매칭하지 않는다 — 사용자 정체성
 * 조회라 personal 토큰이면 충분하고 org 멤버가 아니어도(초대 수락 전 등) 호출할 수 있어야 한다.
 *
 * `provideSpinoffAuth({ resolveOrgScopedId })`로 등록한다 — `spinoff-auth.interceptor.ts`가
 * 받는 `path`는 Angular 라우트가 아니라 이 함수가 매칭하는 **HTTP 요청 URL**(백엔드 API 호출
 * 경로)이다. 이 함수를 등록하는 데 Angular 라우팅 아키텍처(`orgs/:orgId` 라우트 트리,
 * `withComponentInputBinding()`, org 스위처 동작)는 전혀 필요 없다 — org access token 발급
 * 여부만 결정한다. 등록 전제조건은 `provideSpinoffAuth` 문서(`spinoff-auth.config.ts`) 참고 —
 * 백엔드에 org role resolver(`SessionService.setOrgRoleResolver`)를 등록하지 않은 앱에서
 * 이 콜백까지 설정하면 org 토큰 발급이 401로 실패한다.
 */
const ORG_SCOPED_ROUTE = /^\/orgs\/([^/]+)\/./;

export function resolveOrgScopedId(path: string): string | null {
  return ORG_SCOPED_ROUTE.exec(path)?.[1] ?? null;
}
